import Notification from './notification'

class HeaderNotifications extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      notifications: [],
      loading: false
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.visible == false && this.props.visible) {
      this.fetchNotifications()
    }
  }

  handleDelete(e) {
    e.preventDefault()
  }

  fetchNotifications(quiet = false) {
    let _this = this
    jQuery.ajax({
      method: 'GET',
      url: this.props.data.api_path + '/notifications',
      data: {
        per: 10
      },
      beforeSend: function () {
        if (!quiet) _this.setState({ loading: true })
      },
      success: (data) => {
        this.setState({ notifications: data.results })
      },
      complete: function () {
        if (!quiet) _this.setState({ loading: false })
      }
    })
  }

  updateNotification(notification_id, data) {
    let notification = _.find(this.state.notifications, { id: notification_id })

    if (notification) {
      let notifications = this.state.notifications.map((i) => {
        if (i.id == notification.id) {
          return Object.assign(i, data)
        } else {
          return i
        }
      })
      this.setState({ notifications: notifications })

      let _this = this
      jQuery.ajax({
        method: 'PATCH',
        url: this.props.data.api_path + '/notifications/' + notification_id,
        data: {
          notification: data
        },
        success: (data) => {
          _this.fetchNotifications(true)
          window.app.fetchData(true)
        }
      })
    }
  }

  render() {
    let notifications = this.state.notifications.filter((i) => ['unread', 'pending'].includes(i.status)).slice(0, 5)

    return (
      <div className={classNames('header-notifications', { hidden: !this.props.visible })}>
        <div className="inner">
          {this.state.loading ? (
            <div className="text-center">
              <div className="progress-spinner-icon dark"></div>
            </div>
          ) : notifications.length ? (
            <div className="notifications-container">
              {notifications.map((notification) => (
                <Notification
                  key={notification.id}
                  notification={notification}
                  updateNotification={this.updateNotification.bind(this)}
                  notificationsPath={this.props.data.api_path + '/notifications'}
                />
              ))}
            </div>
          ) : (
            <div className="text-center">{I18n.t('you-have-no-notification')}</div>
          )}
        </div>
        <a
          href={this.props.data.notifications_path}
          className="show-more"
          onClick={(e) => window.app.refs.header.setState({ headerNotifications: false })}
        >
          {I18n.t('show-all')}
        </a>
      </div>
    )
  }
}

export default HeaderNotifications
